import { ArrowDropDown, Edit } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import React,{useState} from 'react'
import documentServices from '../services/documentServices';
import { useAlert } from '../../../context/AlertContext';

function DocumentMasterUpdate({masterName,  documentId, masterId , masters, getMasterLabel,callBack}) {
    const {AppAlert} = useAlert();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);


    const getFieldName = () =>{
        let fieldName = masterName;
        switch(masterName){
            case "department":
                fieldName = "department";
                break;
            case "document-category":
                fieldName = "category";
                break;
            case "document-type":
                fieldName = "documentType";
                break;
            case "document-status":
                fieldName = "documentStatus"
                break;
        }
        return fieldName;
    }

    const getActivityRemark = (newId) =>{
        let activity = masterName;
        switch(masterName){
            case "department":
                activity = "Department "
                break;
            case "document-category":
                activity = "Category";
                break;
            case "document-type":
                activity = "Document Type";
                break;
            case "document-status":
                activity = "Status"
                break;
        }
        return activity+' "'+getMasterLabel(masterName,masterId)+'" to "'+getMasterLabel(masterName,newId)+'"';
    }

    const updateStatus = (newId) =>{
        let payload = {
            documentId:documentId,
            fieldName:getFieldName(),
            remark:getActivityRemark(newId),
            newId:newId,
        }
        console.log(payload);
        setSavingStatus(true);
        documentServices.updateMasterStatus(payload).then(res=>{
            console.log(res);
            AppAlert(res.msg)
            callBack();
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            <button className='btn btn-primary' onClick={()=>setDialogStatus(true)}> {getMasterLabel(masterName,masterId)} <ArrowDropDown/>  </button>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle> Update Status : <button className='btn btn-primary'> {getMasterLabel(masterName,masterId)} </button></DialogTitle>
                <DialogContent>
                    <div className='mt-2'>
                        {masters[masterName].map(m=>
                            m.value != masterId && <button className='btn btn-outline-primary m-2' key={m.value} onClick={()=>updateStatus(m.value)} > {m.label} </button>
                        )}
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default DocumentMasterUpdate